// import * as React from 'react';
import { useCookies } from 'react-cookie';
import { CookieNames } from '../constants';

export const useAccessToken = (): string | undefined => {
  const [cookies] = useCookies([CookieNames.accessToken]);
  return cookies[CookieNames.accessToken];
};
